import Marquee from "react-fast-marquee";
import { Reveal } from "./Reveal";
import { CLIENTS } from "../data";

const LogoItem = ({ client }) => (
  <div
    data-testid={`client-${client.name.toLowerCase().replace(/\s+/g, "-")}`}
    title={client.name}
    className="group mx-8 lg:mx-14 flex h-24 lg:h-28 items-center justify-center"
  >
    {client.logo ? (
      <img
        src={client.logo}
        alt={client.name}
        loading="lazy"
        className="max-h-12 lg:max-h-16 w-auto object-contain grayscale opacity-50 group-hover:grayscale-0 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500"
      />
    ) : (
      <span className="font-display font-bold text-2xl lg:text-3xl tracking-tight text-foreground/40 group-hover:text-primary transition-colors duration-500 whitespace-nowrap">
        {client.name}
      </span>
    )}
  </div>
);

export const Clients = () => {
  const mid = Math.ceil(CLIENTS.length / 2);
  const rowOne = CLIENTS.slice(0, mid);
  const rowTwo = CLIENTS.slice(mid);

  return (
    <section id="clients" data-testid="clients-section" className="relative py-16 lg:py-24">
      <Reveal className="mb-10 lg:mb-14 px-6 lg:px-12 flex flex-col lg:flex-row lg:items-end justify-between gap-6">
        <div>
          <p className="inline-block bg-primary text-primary-foreground px-4 py-2 text-xs sm:text-sm uppercase tracking-[0.25em] font-bold">Trusted by</p>
          <h2 className="mt-6 font-display font-extrabold text-5xl sm:text-6xl lg:text-7xl uppercase tracking-tighter leading-[0.9]">
            Good
            <br />
            company.
          </h2>
        </div>
        <p className="font-body text-base text-foreground/60 max-w-sm lg:text-right">
          From heritage giants to challenger brands — a few of the names we&apos;ve built, filmed and
          scaled with.
        </p>
      </Reveal>

      <div className="flex flex-col gap-4 lg:gap-6 border-y border-foreground/10 py-8 lg:py-12">
        <Marquee speed={40} gradient={false} pauseOnHover autoFill>
          {rowOne.map((client) => (
            <LogoItem key={client.name} client={client} />
          ))}
        </Marquee>
        <Marquee speed={40} gradient={false} direction="right" pauseOnHover autoFill>
          {rowTwo.map((client) => (
            <LogoItem key={client.name} client={client} />
          ))}
        </Marquee>
      </div>
    </section>
  );
};
